<template>
  <div>
    <app-button
      v-if="!isEditing"
      data-qa="edit-configuration-code-button"
      :disabled="disabled"
      class="fixedheight-btn"
      @click="toggleEditState()"
      ><icon class="icon" icon="pencil"
    /></app-button>
    <div v-else class="code-form">
      <form-input
        id="configuration-code"
        v-model.lazy="configurationCode"
        :show-label="false"
        :title="i18n.t('/Configuration/ConfigurationCode')"
        maxlength="50"
        type="text"
      />
      <app-button data-qa="save-configuration-code-button" @click="submit">{{
        i18n.t('/Common/Save')
      }}</app-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    FormInput,
    AppButton,
    Icon,
  },
  props: {
    orderService: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isEditing: false,
      configurationCode: '',
    }
  },
  computed: {
    ...mapState({
      stateConfigurationCode(state) {
        return state[this.orderService.type]?.car?.ConfigurationCode
      },
    }),
  },
  methods: {
    async submit() {
      EventBus.$emit('configuration-change', this.configurationCode.trim())
      this.toggleEditState()
    },
    toggleEditState() {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.configurationCode = this.stateConfigurationCode
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.code-form {
  display: flex;
}

.fieldset-inline {
  display: inline;
}

.fixedheight-btn {
  height: 44px;
  vertical-align: middle;
}
</style>
>
